export type PaneType = "files" | "search" | "gitlog" | "terminal" | "scratchpad" | "sessions" | "browser"
export type PanePresentation = "modal" | "docked"

const PANE_PRESENTATION_STORAGE_KEY = "wildlark:task-pane-presentations:v1"
const PANE_TYPES: readonly PaneType[] = ["files", "search", "gitlog", "terminal", "scratchpad", "sessions", "browser"]

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === "object" && value !== null && !Array.isArray(value)
}

function isPaneType(value: unknown): value is PaneType {
    return PANE_TYPES.some((pane) => pane === value)
}

function readDockedPaneTypes(): Set<PaneType> {
    const docked = new Set<PaneType>()
    if (typeof window === "undefined") return docked

    try {
        const serialized = window.localStorage.getItem(PANE_PRESENTATION_STORAGE_KEY)
        if (!serialized) return docked
        const parsed: unknown = JSON.parse(serialized)
        if (!isRecord(parsed) || !Array.isArray(parsed.docked)) return docked
        for (const pane of parsed.docked) {
            if (isPaneType(pane)) docked.add(pane)
        }
    } catch {
        return docked
    }

    return docked
}

export function preferredPanePresentation(pane: PaneType): PanePresentation {
    return readDockedPaneTypes().has(pane) ? "docked" : "modal"
}

export function rememberPanePresentation(pane: PaneType, presentation: PanePresentation): void {
    if (typeof window === "undefined") return

    try {
        const docked = readDockedPaneTypes()
        if (presentation === "docked") docked.add(pane)
        else docked.delete(pane)
        window.localStorage.setItem(PANE_PRESENTATION_STORAGE_KEY, JSON.stringify({ docked: PANE_TYPES.filter((candidate) => docked.has(candidate)) }))
    } catch {
        return
    }
}
